var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("Channels")]),_c('v-card-text',[_c('v-row',[_c('v-col',[_c('div',[_vm._v("None")])])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }